import { Grid } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { H3 } from "../NormalFonts";
import { TitleProps } from "./data";
import styles from "./styleModule";

const Title: React.FC<TitleProps> = ({
  title = "Title",
  subtitle = "Subtitle",
  customTitleContainer = "",
  needHome = false,
}) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();

  return (
    <div
      className={`${styles.titleContainer} ${
        screens.sm ? "" : styles.mobile
      } ${customTitleContainer}`}
    >
      <H3 className={styles.title} weight="heavy" color="var(--primary)">
        {needHome ? (
          <a
            onClick={() => navigate("/")}
            className={styles.homeLink}
          >{`${t("header.menu.home")}/ `}</a>
        ) : (
          <></>
        )}
        {title}
      </H3>
      {/* {screens.sm ? (
        <div className={styles.subContainer}>
          <div className={styles.border} />
          <H6
            className={styles.subtitle}
            weight="medium"
            color="var(--primary-10)"
          >
            {subtitle}
          </H6>
        </div>
      ) : null} */}
    </div>
  );
};

export default Title;
